export const UserPresenceStatus = Object.freeze({
  ACTIVE: "active",
  REVIEW: "review",
  LOCKED: "locked",
  OFFLINE: "offline",
});

export const UserPresenceStatusColor = {
  [UserPresenceStatus.ACTIVE]: "bg-green-500",
  [UserPresenceStatus.REVIEW]: "bg-orange-500",
  [UserPresenceStatus.LOCKED]: "bg-red-500",
  [UserPresenceStatus.OFFLINE]: "bg-gray-500",
};
